var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('../../template/msg/remind-msg-item.html');
/*require('./../../style/msg/tip-msg-item.less');*/
var dispatcher = require('./../../global/dispatcher');
var ActionType = require('./../../constant/ActionType');
var platform = require('../../../lib/platform');
var TextMsgItem = require('./TextMsgItem');
var FileMsgItem = require('./FileMsgItem');
var AudioMsgItem = require('./AudioMsgItem');
var CardMsgItem = require('./CardMsgItem');
var CardMsgItem4 = require('./CardMsgItem4');
var CardMsgItem5 = require('./CardMsgItem5');
var CardMsgItemGanji = require('./CardMsgItemGanji');
var CardMsgJob = require('./CardMsgJob');
var MiniCardMsgItem = require('./MiniCardMsgItem');
var MixMsgItem = require('./MixMsgItem');
var CardMsgMutual = require('./CardMsgMutual');
var CardBatchMsgItem = require('./CardBatchMsgItem');
var config = require('./../../global/config');
var util = require('./../../global/utils');
const { isEmpty, ymdhFormat, jsonHandler } = require('./../../global/utils');
const ContactStatus = require('../../constant/ContactStatus');

var updateVideoInfo = function (content, element) {
    // 视频预览图大小''
    var msgcontent = content;
    var fitSarari = platform.name.indexOf('Safari') !== -1;
  
    var renderImage = function (options) {
      var imgParams = util.getImgParams(options);
      var $content = element;
      $content.css({
        'height': imgParams.height + 'px',
        'width': imgParams.width + 'px',
        'background-size': imgParams.background_size,
        'background-image': 'url(' + imgParams.url + ')',
        'background-repeat': 'no-repeat',
        'background-position': 'center'
      });
    };
  
    // if(fitSarari){
    //   fileHandler.createThumbnail(msgcontent.url, function (thumbnailObj) {
    //     var options = {
    //       minsize: 50,
    //       maxsize: 250,
    //       image_width: thumbnailObj.width,
    //       image_height: thumbnailObj.height,
    //       url: thumbnailObj.duration ? thumbnailObj.data : config['default-card-img']
    //     };
    //     renderImage(options);
    //   });
    // }else{
    var options = {
      minsize: 100,
      maxsize: 100,
      image_width: msgcontent.thumbnail_width,
      image_height: msgcontent.thumbnail_height,
      url: (!msgcontent.thumbnail_url || msgcontent.thumbnail_url.indexOf('data:') !== -1 || !msgcontent.thumbnail_url.indexOf('//') === -1) ? config['default-card-img'] : msgcontent.thumbnail_url
    };
    if (fitSarari) {
      var setThumbnailUrl = function (thumbnail_url) {
        if (thumbnail_url && thumbnail_url.length > 1 && msgcontent.thumbnail_url.indexOf('.mp4') == -1) {
          options.url = msgcontent.thumbnail_url;
        } else {
          options.url = config['default-card-img'];
        }
      }
      var thumbnail_url = msgcontent.thumbnail_url;
      if (msgcontent.thumbnail_url && msgcontent.thumbnail_url.indexOf('data:') > -1) {
        thumbnail_url = msgcontent.thumbnail_url.replace('data:', '');
      }
      setThumbnailUrl(thumbnail_url);
    }
    return options;
    //renderImage(options);
    // }
};

var updateImageInfo = function (content, element) {
    let options = {
        minsize: 100,
        maxsize: 100,
        image_width: content.image_width,
        image_height: content.image_height,
        url: content.url
    };
    let imgParams = util.getImgParams(options);
    element.css({
        'height': imgParams.height + 'px',
        'width': imgParams.width  + 'px',
        'background-size': imgParams.background_size,
        'background-image': 'url(' + imgParams.url + ')',
        'background-repeat': 'no-repeat'
    });
}

var RemindMsgItem = function (options) {
    (function (self) {
        var defaults = {
            template: template,
            onImageClick: function (images) {
                dispatcher.dispatch({
                    type: ActionType.IMAGE_CLICK,
                    data: {
                      images,
                      current: 0
                    }
                  });
            }
        };
        $.extend(defaults, options);
        BaseMsgItem.call(self, defaults);
    })(this);
};

RemindMsgItem.prototype = Object.create(BaseMsgItem.prototype);

RemindMsgItem.prototype.renderContent = function () {
    let self = this;
    let MsgItem;
    let fill_content = '';
    let msg_class = '';
    let content = {};
    let msgContent = {};
    let remindMsg = {};
    let remindMsgsPreview;
    /* text */
    // content = {
    //     msg: '我们将在【义勇军进行曲】召开《微聊新增匿名聊天、提醒功能》方案讨论。这个时间有空不？这个时间有空不？这个时间有空不？这个时间有空不？',
    //     type: 'text'
    // };
    /* image */
    // content = {
    //     "image_width":"850.000000",
    //     "image_height":"638.000000",
    //     "localPath":"7179DA52F81C4BEFE8EA71E4186FACC3",
    //     "type":"image",
    //     "url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v29a226611a44842bf8685cd51b693bd8f.jpg"
    // }
    /* video */
    // content = {
    //     "type": "video",
    //     "url": "https://jcwos.58cdn.com.cn/kqiHgFeDcko/bucket108video/20120414-3522-0000-0014-5065f3669280.mp4",
    //     "thumbnail_url": "https://jcwos.58cdn.com.cn/kqiHgFeDcko/bucket108/20120414-3523-0000-001a-48df37203dcc.jpg",
    //     "thumbnail_width": 960,
    //     "thumbnail_height": 544,
    //     "duration": 6.698667,
    //     "wos_file_name": "20120414-3522-0000-0014-5065f3669280.mp4",
    //     "size": 1018633,
    //     "format": "video/mp4",
    //     "extra": ""
    // }
    /* universal_card1 */
    // content = {
    //     "type": "universal_card1",
    //     "card_title": "举报结果通知",
    //     "card_content": "您举报的用户“不吃草的小马”经审核存在欺诈行为，已被封禁，感谢您的举报",
    //     "card_action_url": "https:\/\/www.baidu.com\/",
    //     "card_location": 0
    // }
    /* universal_card6 */
    // content = {
    //   "type":"universal_card6",
    //   "card_title":"电子城小区招聘送货工电子城小区招聘送货工",
    //   "card_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg",
    //   "card_content":"3000元\/月 五险一金  电子城小区招聘送货工电子城小区招聘送货工   电子城小区招聘送货工电子城小区招聘送货工  电子城小区招聘送货工电子城小区招聘送货工",
    //   "card_subContent":"这里是附加信息",
    //   "card_action_url":"https:\/\/www.baidu.com\/",
    //   "card_btnArray":[{"card_sub_btnId":"4","card_sub_btnTitle":"取消"},{"card_sub_btnId":"3","card_sub_btnTitle":"确认"}]
    // }
    /* universal_card4 */
    // content = {
    //   "type":"universal_card4",
    //   "card_title":"北京2017房价走势，看好走势，北京2017房价走势，看好走势，投资有保障北京2017房价走势，看好走势，投资有保障北京2017房价走势，看好走势，投资有保障",
    //   "card_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg",
    //   "card_picture_w":450,
    //   "card_picture_h":240,
    //   "card_content_array":[{
    //     "card_sub_title":"关于租房，你最关心的那些事关于租房，关于租房，你最关心的那些事关于租房，你最关心的那些事关于租房，你最关心的那些事",
    //     "card_sub_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg",
    //     "card_sub_picture_w":0,
    //     "card_sub_picture_h":0,
    //     "card_sub_action_url":"https:\/\/bj.58.com\/"
    //     },
    //     {"card_sub_title":"关于租房，你最关心的那些事关于租房，关于租房，你最关心的那些事关于租房，你最关心的那些事关于租房，你最关心的那些事",
    //     "card_sub_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg",
    //     "card_sub_picture_w":0,
    //     "card_sub_picture_h":0,
    //     "card_sub_action_url":"https:\/\/bj.58.com\/"
    //   }],
    //   "card_action_url":"https:\/\/bj.58.com\/",
    //   "card_location":0
    // }
    /* universal_card3 */
    // content = {
    //   "type":"universal_card3",
    //   "card_title":"北京2017房价走势，看好走势，投资有保障，看好走势，投资有保障，看好走势，投资有保障北京2017房价走势，看好走势，投资有保障，看好走势，投资有保障，看好走势，投资有保障",
    //   "card_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg",
    //   "card_picture_w":450,
    //   "card_picture_h":240,
    //   "card_content":"一大波案例来袭一大波案例来袭一大波案例来袭一大波案例来袭一大波案例来袭一大波案例来袭一大波案例来袭~",
    //   "card_action_url":"https:\/\/bj.58.com\/",
    //   "card_location":0
    // }
    /* universal_card5 */
    // content = {"type":"universal_card5","card_content_array":[{"card_sub_title":"电子城小区招聘送货工电子城小区招聘送货工","card_sub_content":"朝阳 | 酒仙桥 | 1000m | 别墅","card_sub_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg","card_sub_picture_w":0,"card_sub_picture_h":0,"card_sub_action_url":"http:\/\/bj.58.com\/","card_sub_price":"200\/月","card_sub_labels":["包吃","奖金","五险一金"]},{"card_sub_title":"电子城小区招聘送货工电子城小区招聘送货工","card_sub_content":"朝阳 | 酒仙桥 | 1000m | 别墅","card_sub_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg","card_sub_picture_w":0,"card_sub_picture_h":0,"card_sub_action_url":"http:\/\/bj.58.com\/","card_sub_price":"200\/月","card_sub_labels":["包吃","奖金","五险一金"]},{"card_sub_title":"电子城小区招聘送货工电子城小区招聘送货工","card_sub_content":"朝阳 | 酒仙桥 | 1000m | 别墅","card_sub_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg","card_sub_picture_w":0,"card_sub_picture_h":0,"card_sub_action_url":"http:\/\/bj.58.com\/","card_sub_price":"200\/月","card_sub_labels":["包吃","奖金","五险一金"]},{"card_sub_title":"电子城小区招聘送货工电子城小区招聘送货工","card_sub_content":"朝阳 | 酒仙桥 | 1000m | 别墅","card_sub_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg","card_sub_picture_w":0,"card_sub_picture_h":0,"card_sub_action_url":"http:\/\/bj.58.com\/","card_sub_price":"200\/月","card_sub_labels":["包吃","奖金","五险一金"]},{"card_sub_title":"电子城小区招聘送货工电子城小区招聘送货工","card_sub_content":"朝阳 | 酒仙桥 | 1000m | 别墅","card_sub_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg","card_sub_picture_w":0,"card_sub_picture_h":0,"card_sub_action_url":"http:\/\/bj.58.com\/","card_sub_price":"200\/月","card_sub_labels":["包吃","奖金","五险一金"]},{"card_sub_title":"电子城小区招聘送货工电子城小区招聘送货工","card_sub_content":"朝阳 | 酒仙桥 | 1000m | 别墅","card_sub_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg","card_sub_picture_w":0,"card_sub_picture_h":0,"card_sub_action_url":"http:\/\/bj.58.com\/","card_sub_price":"200\/月","card_sub_labels":["包吃","奖金","五险一金"]},{"card_sub_title":"电子城小区招聘送货工电子城小区招聘送货工","card_sub_content":"朝阳 | 酒仙桥 | 1000m | 别墅","card_sub_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg","card_sub_picture_w":0,"card_sub_picture_h":0,"card_sub_action_url":"http:\/\/bj.58.com\/","card_sub_price":"200\/月","card_sub_labels":["包吃","奖金","五险一金"]},{"card_sub_title":"电子城小区招聘送货工电子城小区招聘送货工","card_sub_content":"朝阳 | 酒仙桥 | 1000m | 别墅","card_sub_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg","card_sub_picture_w":0,"card_sub_picture_h":0,"card_sub_action_url":"http:\/\/bj.58.com\/","card_sub_price":"200\/月","card_sub_labels":["包吃","奖金","五险一金"]},{"card_sub_title":"电子城小区招聘送货工电子城小区招聘送货工","card_sub_content":"朝阳 | 酒仙桥 | 1000m | 别墅","card_sub_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg","card_sub_picture_w":0,"card_sub_picture_h":0,"card_sub_action_url":"http:\/\/bj.58.com\/","card_sub_price":"200\/月","card_sub_labels":["包吃","奖金","五险一金"]}],"card_list_url":"https:\/\/bj.58.com\/","card_title":"房源信息","card_version":"","card_source":"","card_location":0}
    /* universal_card2 */
    //content = {"type":"universal_card2","card_title":"电子城小区业主急租复式三居随时可看有电梯拎包入住","card_picture_url":"https:\/\/pic1.58cdn.com.cn\/im\/v1\/n_v25c83dbe3982943ffa7ee7135f50e9a7f.jpg","card_content":"朝阳 | 酒仙桥 | 1000m | 别墅","card_action_url":"https:\/\/www.baidu.com\/","card_price":"不赚钱，交个朋友","card_labels":["个人房源","押一付一","近地铁","送保姆"],"card_location":0,"card_show_type":0}
    /* msg_batch_forward_card */
    // content = {"type":"msg_batch_forward_card","card_title":"群聊的聊天记录","msgs":[{"msg_id":"1335153606340427777","sender_id":"1999@@108","to_id":"3093@@10108"},{"msg_id":"1335153790881423361","sender_id":"1999@@108","to_id":"3093@@10108"}],"msgs_preview":[{"sender_name":"user1999","avatar":"http://pic1.58cdn.com.cn/nowater/p1/n_v1bl2lwtkamtfvrr7mzzwq.png","content":"{\"type\":\"audio\",\"url\":\"https:\\/\\/jcwos.58cdn.com.cn\\/vBtSrQpOnvx\\/bucket108\\/20120517-2639-0000-001e-48df37203dcc.amr\",\"duration\":2,\"extra\":\"\",\"wos_file_name\":\"20120517-2639-0000-001e-48df37203dcc.amr\"}"},{"sender_name":"user1999","avatar":"http://pic1.58cdn.com.cn/nowater/p1/n_v1bl2lwtkamtfvrr7mzzwq.png","content":"{\"type\":\"video\",\"url\":\"https:\\/\\/jcwos.58cdn.com.cn\\/vBtSrQpOnvx\\/bucket108video\\/20120517-2718-0000-001f-48df37203dcc.mp4\",\"wos_file_name\":\"20120517-2718-0000-001f-48df37203dcc.mp4\",\"size\":512605,\"duration\":2,\"format\":\"video\\/mp4\",\"thumbnail_url\":\"https:\\/\\/pic1.58cdn.com.cn\\/im\\/v1\\/n_v240515f4bbf6446598717e86e125fd0de.jpg\",\"thumbnail_width\":\"239.0\",\"thumbnail_height\":\"500.0\",\"extra\":\"\"}"}],"forward_one_by_one":false}
    /* file */
    // content = {
    //   "type":"file",
    //   "url":"https://jcwos.58cdn.com.cn/kqiHgFeDcko/bucket108/20120914-3807-0000-0001-48df37203dcc.pdf",
    //   "wos_file_name":"20120914-3807-0000-0001-48df37203dcc.pdf",
    //   "size":989144,
    //   "format":"application/pdf",
    //   "extra":"",
    //   "original_file_name":"2019.04.19-殷圣魁-前端也能做ai.pdf"
    // };
    /* text */
    //content = {"msg":"hello, https://www.baidu.com","type":"text"};
    if (self._data.msg && self._data.msg.content) {
      msgContent = self._data.msg.content;
    }
    let avatar;
    if (msgContent  && msgContent.msgs_preview && msgContent.msgs_preview.length) {
      content = msgContent.msgs_preview[0] && msgContent.msgs_preview[0].content ? msgContent.msgs_preview[0].content : {};
      avatar = msgContent.msgs_preview[0] && msgContent.msgs_preview[0].avatar ? msgContent.msgs_preview[0].avatar : '';
      if (typeof content === 'string') {
        try {
          content = JSON.parse(content);
        } catch(e) {
          content = {};
        }
      }
    }
    if (msgContent  && msgContent.msgs && msgContent.msgs.length) {
      remindMsg = msgContent.msgs[0];
      // let _remindMsg_id_source
      // if (remindMsg.sender_id) {
      //   _remindMsg_id_source = remindMsg.sender_id;
      //   remindMsg.sender_id = '';
      //   _remindMsg_id_source = _remindMsg_id_source.split('@@');
      //   if (_remindMsg_id_source.length == 2) {
      //     remindMsg.sender_id = _remindMsg_id_source[0];
      //     remindMsg.sender_source = _remindMsg_id_source[1];
      //   }
      // }
      // if (remindMsg.to_id) {
      //   _remindMsg_id_source = remindMsg.to_id;
      //   remindMsg.to_id = '';
      //   _remindMsg_id_source = _remindMsg_id_source.split('@@');
      //   if (_remindMsg_id_source.length == 2) {
      //     remindMsg.to_id = _remindMsg_id_source[0];
      //     remindMsg.to_source = _remindMsg_id_source[1];
      //   }
      // }
    }
    if (msgContent && msgContent.msgs_preview && msgContent.msgs_preview.length) {
      remindMsgsPreview = msgContent.msgs_preview[0];
    }
    let msg_show_type = content.type;
    if (!config['is_support_forward'] && ['msg_batch_forward_card'].indexOf(msg_show_type) >= 0) {
      msg_show_type = null;
    }
    switch(msg_show_type) {
        case 'text':
            MsgItem = new TextMsgItem({});
            msg_class = 'im-msg-text';
            // fill_content = content.msg
            break;
        case 'audio':
            fill_content = $('<div class="im-msg-audio"><div class="im-msg-main"><span class="im-msg-content"></span><span class="im-msg-duration"></span><span class="im-msg-read-status im-audio-read"></span></div></div>');
            var msg_main = fill_content.find('.im-msg-main');
            var dur = fill_content.find('.im-msg-duration');
            var width = (15 + 5 * content.duration);
            var icon = msg_main.find('.im-msg-content');
            if (content.duration >= 60) {
                icon.addClass('im-audio-60');
                // width = 228;
                width = 280;
            } else if (content.duration >= 30) {
                icon.addClass('im-audio-30');
                // width = 148;
                width = 200;
            }
            width = width <= 165 ? 90 : width;
            msg_main.width(width);
            dur.text(content.duration + '秒');
            let msg = {
              msg_id: remindMsg.msg_id,
              // sender_id: remindMsg.sender_id,
              // sender_source: remindMsg.sender_source,
              // to_id: remindMsg.to_id,
              // to_source: remindMsg.to_source,
              content,
              status: 'SUCCESS'
            }
            let oldUrl = msg.content.url;
            msg.content.url = config['audio-converter'](oldUrl);
            msg.content.oldUrl = oldUrl;
            msg_main.click(function () {
              if (msg_main.find('.im-audio-playing').length === 0) {
                  dispatcher.dispatch({
                      type: ActionType.MSG_AUDIO_READ,
                      data: msg
                  });
              } else {
                  dispatcher.dispatch({
                      type: ActionType.MSG_AUDIO_READ_END,
                      data: msg
                  });
              }
            });
            dispatcher.register(function (action) {
              if (!action.data || !action.type || !action.data.msg_id || !msg_main) {
                  return;
              }
              if (action.data.msg_id === msg.msg_id) {
                  switch (action.type) {
                      case ActionType.MSG_AUDIO_ACK_READ:
                          msg_main.find('.im-msg-read-status').addClass('im-audio-read');
                          break;
                      case ActionType.MSG_AUDIO_READ_START:
                          msg_main.find('.im-msg-content').addClass('im-audio-playing');
                          break;
                      case ActionType.MSG_AUDIO_READ_END:
                          msg_main.find('.im-msg-content').removeClass('im-audio-playing');
                          break;
                      default:
                          break;
                  }
              } else {
                  if (action.type === ActionType.MSG_AUDIO_READ_START) {
                      msg_main.find('.im-msg-content').removeClass('im-audio-playing');
                  }
              }
          });
            break;
        case 'image':
            fill_content = $('<div class="im-msg-remind-image"></div>');
            updateImageInfo.call(self, content, fill_content);
            fill_content.click(function () {
                self._options.onImageClick([{
                    src: content.url,
                    image_width: content.image_width,
                    image_height: content.image_height
                }]);
            });
            break;
        case 'video':
            var msgText = msg_show_type === 'video' ? '视频' : '语音';
            // 针对IE8及以下浏览器不支持audio标签，转换显示文案
            if (!(document.createElement('video').canPlayType)) {
              fill_content = '浏览器版本不支持' + msgText + '播放，请升级浏览器';
            } else {
              fill_content = $('<div class="im-msg-remind-video"><img class="im-msg-remind-video-cover"><a href="javascript:;" class="im-msg-remind-video-btn"></a></div>');
              var imgOptions = updateVideoInfo.call(self, content, fill_content);
              fill_content.find('.im-msg-remind-video-cover').attr('src', imgOptions.url);
              fill_content.css('max-width', 100 * imgOptions.image_width / imgOptions.image_height);
              let $videoPlayBtn = fill_content.find('.im-msg-remind-video-btn');
              $videoPlayBtn.click(function () {
                  if (isEmpty(remindMsgsPreview.to_source)) {
                    return;
                  }
                  dispatcher.dispatch({
                    type: ActionType.VIDEO_PLAY,
                    data: {
                      content,
                      to_source: remindMsgsPreview.to_source
                    }
                  });
              });
            }
            break;
        case 'file':
            MsgItem = new FileMsgItem({});
            msg_class = 'im-msg-file';
            break;
        case 'audio':
            MsgItem = new AudioMsgItem({});
            msg_class = 'im-msg-audio';
            break;
        case 'card':
            MsgItem = new CardMsgItem({});
            msg_class = 'im-msg-card';
            break;
        case 'minicard':
        case 'universal_card2':
            MsgItem = new MiniCardMsgItem({});
            msg_class = 'im-msg-minicard';
            break;
        case 'mix':
        case 'universal_card1':
        case 'universal_card3':
            MsgItem = new MixMsgItem({});
            msg_class = 'im-msg-mix';
            break;
        case 'universal_card4':
            MsgItem = new CardMsgItem4({});
            msg_class = 'im-msg-card im-msg-card4';
            break;
        case 'universal_card5':
            MsgItem = new CardMsgItem5({});
            msg_class = 'im-msg-mix im-msg-card5';
            break;
        case 'universal_card6':
            MsgItem = new CardMsgMutual({});
            msg_class = 'im-msg-mutual';
            break;
        case 'private_card_ganji':
            MsgItem = new CardMsgItemGanji({});
            msg_class = 'im-msg-mix im-msg-card5 im-msg-ganji';
            break;
        case 'wuba_card':
            MsgItem = new CardMsgJob({});
            msg_class = 'im-msg-job';
            break;
        case 'msg_batch_forward_card':
            MsgItem = new CardBatchMsgItem({});
            msg_class = 'im-msg-batch-card';
            break;
        default:
            fill_content = '消息格式暂不支持，请在客户端查看';
            break;
    }
    if (!isEmpty(MsgItem)) {
      MsgItem.setMsg({
        msg_id: remindMsg.msg_id,
        sender_id: remindMsg.sender_id,
        sender_source: remindMsg.sender_source,
        to_id: remindMsg.to_id,
        to_source: remindMsgsPreview.to_source,
        content,
        status: 'SUCCESS'
      });
      fill_content = $('<div class="im-msg-remind-card ${msg-class}"><div class="im-msg-main"></div></div>'.replace('${msg-class}', msg_class));
      switch (msg_show_type) {
        case 'audio':
          fill_content.find('.im-msg-main').html(MsgItem.getElement().find('.im-msg-main'));
          break;
        case 'msg_batch_forward_card':
          /* 
            forward_msg_id: "1341679321059745792"
            forward_sender_id: "1154"
            forward_sender_source: 108
            forward_to_id: "8973"
            forward_to_source: 10108,
            msgs: ["1341659625178587138"]
          */
          MsgItem.getElement().find('.im-msg-content').unbind("click");
          MsgItem.getElement().find('.im-msg-content').click(function (e) {
            e.stopPropagation();
            let msg = self._data.msg;
            webimbiz.getForwardMsg({
              forward_msg_id: msg.msg_id,
              forward_sender_id: msg.sender_id,
              forward_sender_source: msg.sender_source,
              forward_to_id: msg.to_id,
              forward_to_source: msg.to_source,
              msgs: [msgContent.msgs[0].msg_id]
            }, function(forward_messages) {
              let forward_message = (forward_messages && forward_messages.length) ? forward_messages[0] : null;
              if (forward_message) {
                try {
                  forward_message.content = jsonHandler.parse(forward_message.content)
                } catch(e) {

                }
                forward_message.msg_id = msg.forward_msg_id ? msg.forward_msg_id : msg.msg_id;
                forward_message.sender_id = msg.sender_id;
                forward_message.sender_source = msg.sender_source;
                forward_message.to_id = msg.to_id;
                forward_message.to_source = msg.to_source;
                MsgItem.handleMsgClick.apply(self, [forward_message]);
              }
              /*
                content: {type: "msg_batch_forward_card", card_title: "user1200和user1111的聊天记录", msgs: null, msgs_preview: null, forward_one_by_one: false}
                msg_id: "1341706838319611904"
                sender_id: ""
                sender_source: undefined
                status: "SUCCESS"
                to_id: ""
                to_source: undefined
               */
               //MsgItem.handleMsgClick.apply(self, []);
            }, function() {

            })
          });
          fill_content.find('.im-msg-main').html(MsgItem.getElement().find('.im-msg-content'));
          break;
        default:
          fill_content.find('.im-msg-main').html(MsgItem.getElement().find('.im-msg-content'));
          break;
      }
    } 
    if(!isEmpty(fill_content)){
      this._element.find('.im-msg-content .im-msg-remind-content').html(fill_content);
    }
    if (msgContent) {
      /*
        card_title: "user1016和user1014的聊天记录"
        comment: ""
        creator_id: "1014@@108"
        forward_one_by_one: false
        msgs: [{…}]
        msgs_preview: [{…}]
        notice_id: "1338758673438146560"
        runtime: 1608021042
        type: "wechat_notice_card"
       */
      this._element.find('.im-msg-remind-title .im-msg-remind-text').html(msgContent.card_title).show();
      if(avatar)this._element.find('.im-msg-remind-avatar img').attr('src', avatar).show();
      this._element.find('.im-msg-remind-time .im-msg-remind-text').html(ymdhFormat(msgContent.runtime * 1000 + (!isNaN(msgContent.tasktime) ? msgContent.tasktime * 1000 : 0)));
      this._element.find('.im-msg-remind-words .im-msg-remind-text').html(msgContent.comment);
      this._element.find('.im-msg-remind-avatar').css('background')
    }
};


module.exports = RemindMsgItem;
